module.exports = __webpack_public_path__ + "img/cs1.72c0b94f.png";